import {
  type ReferentialEnum,
  referentialEnumToReferentialCodeList,
} from "@pharmupp/p3-front-commons"

export type UserExternSpecificationName = keyof typeof userExternSpecificationEnum
export const userExternSpecificationEnum = {
  CONTACT_LABORATORY: { label: "Contact Laboratoire" },
} as const satisfies ReferentialEnum

export const userExternSpecificationReferential =
  referentialEnumToReferentialCodeList(userExternSpecificationEnum)
